
/**
 * app_crash
 * Событие отправляется при падении приложения (необработанное исключение, crash)
 */
export interface AppCrashV2 {
  /**
   * текст ошибки/исключения, которое привело к крашу
   */
  error_message: string;
}

export function mapAppCrashV2Event(event: AppCrashV2): object {
  const props: Record<string, unknown> = {
      error_message: event.error_message,
  };

  return {
    event: 'analytics_event',
    event_name: 'app_crash',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
